import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../authmanager/authcontext";
import ErrorModal from "../errormodel/errormodel";
import { checkoutCart, deleteCart } from "../utils/utils";
import Navbar from "../navbar/navbar";
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported

export const CheckoutForm = ({ toggleTheme }) => {
  const navigate = useNavigate();
  const { handleLogout, finalizeCart } = useContext(AuthContext);
  const accessToken = localStorage.getItem("accessToken");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip_code: "",
    phone: "",
  });

  const [errorModalIsOpen, setErrorModalIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const detailsArray = { ...formData };

    const handlePlaceOrderClick = async (detailsArray) => {
      try {
        await checkoutCart(accessToken, detailsArray);
        await deleteCart(accessToken);
        navigate("/payments"); // Navigate to payments only if no errors
      } catch (error) {
        console.error("An error occurred:", error);
        setErrorMessage("An error occurred while placing your order. Please try again.");
        setErrorModalIsOpen(true);
      }
    };

    handlePlaceOrderClick(detailsArray);
  };

  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
    navigate("/home"); // Redirect to home after closing the error modal
  };

  return (
    <div>
      <Navbar toggleTheme={toggleTheme} handleLogout={handleLogout} finalizeCart={finalizeCart} />
      <br />
      <form onSubmit={handleSubmit} className="form-container">
        {/* Form inputs */}
        <h3>Enter your details</h3>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="address">Address:</label>
        <input
          type="text"
          id="address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          required
        />

        <label htmlFor="city">City:</label>
        <input
          type="text"
          id="city"
          name="city"
          value={formData.city}
          onChange={handleChange}
          required
        />

        <label htmlFor="state">State:</label>
        <input
          type="text"
          id="state"
          name="state"
          value={formData.state}
          onChange={handleChange}
          required
        />

        <label htmlFor="zip_code">Zip Code:</label>
        <input
          type="text"
          id="zip_code"
          name="zip_code"
          value={formData.zip_code}
          onChange={handleChange}
          required
        />

        <label htmlFor="phone">Phone:</label>
        <input
          type="text"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <div className="button-container">
          <button type="submit" className="circle">
            Place Order
          </button>
        </div>
      </form>

      {/* Error Modal */}
      <ErrorModal
        show={errorModalIsOpen}
        handleClose={closeErrorModal}
        message={errorMessage}
      />
    </div>
  );
};
